const dedupeById = <T extends Record<string, any>>(items: T[] | undefined): T[] => {
	if (!items) return [];
	const seen = new Set<string>();
	return items.filter((item) => {
		const key = typeof item?.id === 'string' ? item.id : undefined;
		if (!key) return true;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
};

export const withDefaultList = <T>(value: T[] | undefined): T[] => dedupeById(value as Record<string, any>[] | undefined) as T[];

export const withDefaultObject = <T extends Record<string, any>>(value: T | undefined): T => value ?? ({} as T);
